var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormatIconTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 138,
    viewBox: "0 0 60 138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(-1655 -331)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "FormatTimeGray",
    width: 60,
    height: 12,
    rx: 6,
    transform: "translate(1655 331)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "FormatTimeBlue",
    width: 60,
    height: 12,
    rx: 6,
    transform: "translate(1655 373)",
    fill: "#203250"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1528",
    "data-name": "Rectangle 1528",
    width: 60,
    height: 12,
    rx: 6,
    transform: "translate(1655 415)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1530",
    "data-name": "Rectangle 1530",
    width: 60,
    height: 12,
    rx: 6,
    transform: "translate(1655 457)",
    fill: "#bebebe"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatIconTime);
export default __webpack_public_path__ + "static/media/Format_Icon_time.635dd917.svg";
export { ForwardRef as ReactComponent };